import {handleActions} from "redux-actions";
import * as type from './type'

export const initialState = {
    store: {
        'isPartner':0,
        'isPretreatmentProvider':0,
        'iprProvider':0,
        'hasSpecialIprLogic': 0,
        'isImplantProvider':0
    },
    hasChanged: false,
    redirect:false,
    fetching: false,
    validationMessageList: []
}

export default handleActions({
    [type.EDIT_STORE]: (state, action) => {
        const {name, value} = action.payload
        return {
            ...state,
            store: {
                ...state.store,
                [name]: value,
            },
            hasChanged: true,
        }
    },
    [type.SAVE_STORE_REQUEST]: (state) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.SAVE_STORE_SUCCESS]: (state) => {
        return {
            ...state,
            redirect:true
        }
    },
    [type.SAVE_STORE_ERROR]: (state, action) => {
        const {validationMessageList} = action.payload
        return {
            ...state,
            fetching: false,
            validationMessageList,
        }
    },
    [type.FIND_STORE_REQUEST]: (state) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.FIND_STORE_SUCCESS]: (state, action) => {
        const {store} = action.payload
        return {
            ...state,
            store,
            fetching: false
        }
    },
    [type.FIND_STORE_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            error,
        }
    },
    [type.VALIDATION_LIST]: (state, action) => {
        const {list} = action.payload
        return {
            ...state,
            validationMessageList: list
        }
    },
    [type.CLEAR_STATE]: () => {
        return {
            ...initialState
        }
    }
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/store/state/detail/reducer.js